import { CardMedia, Skeleton } from '@mui/material';
import React from 'react';

export default function ImageLoading(props: any) {
  const {
    src,
    loading,
    setLoading,
    heightLoad,
    widthLoad,
    height,
    width,
    skeletonBackground = 'none',
  } = props;

  return (
    <>
      <CardMedia
        alt="image"
        component="img"
        image={src}
        onLoad={() => setLoading(false)}
        sx={{
          display: !loading ? 'block' : 'none',
          height: height,
          width: width,
          objectFit: 'contain',
          borderRadius: 1,
        }}
      />
      {loading ? (
        <Skeleton
          height={heightLoad}
          sx={{ borderRadius: '10px', backgroundColor: skeletonBackground }}
          variant="rectangular"
          width={widthLoad}
        />
      ) : null}
    </>
  );
}
